<ng-container *ngIf="show">
  <span *ngIf="type === 'pulse'" class="position-absolute top-50 end-0 translate-middle-y me-3 error-pulse" tabindex="0">
    <span class="dot"></span>
    <span class="tooltip-text">{{ message }}</span>
  </span>
  <span *ngIf="type === 'question'" class="position-absolute top-50 end-0 translate-middle-y me-3 sleek-circle-tooltip invalid" tabindex="0">
    ?
    <span class="tooltip-text">{{ message }}</span>
  </span>
</ng-container>